import { ReduxNoteTemplateEntity } from '../types'

export const hasEmptyFilter = (entity: ReduxNoteTemplateEntity) => {
  return entity.filter === undefined || Object.keys(entity.filter).length === 0
}
